import { observable } from "mobx";
import { Type } from "class-transformer";
import CounterpartyBankAccountResponse from "./counterpartyBankAccountResponse";
import CustomerRefundPaymentType from "./customerRefundPaymentType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ChargeRefundResponse {
  /**
   * Date and time when amount was refunded to counterparty account; otherwise `null`.
   */
  @observable
  @Type(() => Date)
  refundedAt?: Date;

  @observable
  refundPaymentType!: CustomerRefundPaymentType;

  /**
   * Refunded amount.
   */
  @observable
  amount!: number;

  /**
   * Variable symbol (payment reference) of refundation via bank transfer.
   */
  @observable
  variableSymbol?: number;

  @observable
  @Type(() => CounterpartyBankAccountResponse)
  bankAccount?: CounterpartyBankAccountResponse;
}
